import React from "react";
import { NavLink } from "react-router-dom";

export default function Cost() {
    return (
        <div>
            <div id="pageContainer">
                <span className="sectionHeader"> Tuition and Fees </span>
                <table>
                    <thead>
                        <tr >
                            <th></th>
                            <th>1st Child</th>
                            <th>2nd Child</th>
                            <th>Part Time</th>
                            <th>12.5hr a week</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                INFANTS
                                <br />6 weeks- 21months
                            </td>
                            <td>$379.00</td>
                            <td>$366.00</td>
                            <td>$326.00</td>
                            <td></td>
                        </tr>

                        <tr>
                            <td>
                                TODDLER <br />
                                21 months-3 years{" "}
                            </td>
                            <td>$339.00</td>
                            <td>$329.00</td>
                            <td>$293.00</td>
                            <td></td>
                        </tr>

                        <tr>
                            <td>
                                PRESCHOOL <br />3 years-5 years{" "}
                            </td>
                            <td>$298.00</td>
                            <td>$289.00</td>
                            <td>$259.00</td>
                            <td>$180.00**</td>
                        </tr>
                        <tr>
                            <td>
                                SCHOOL AGE <br />
                            </td>
                            <td>$279.00</td>
                            <td>$265.00</td>
                            <td>$235.00</td>

                            <td></td>
                        </tr>
                        <tr>
                            <td>Before and After</td>
                            <td>$129.00</td>
                            <td>$116.00</td>
                            <td>$103.00</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Before </td>
                            <td>$66.00</td>
                            <td>$60.00 </td>
                            <td>$58.00</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>After </td>
                            <td>$90.00</td>
                            <td>$81.60 </td>
                            <td>$81.00</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <h2>RATE WILL VERY BASED ON TRANSPORTATION NEEDS</h2>
                <p id="rateExplanation">
                    <span id="parHeader"> Registration Fee: </span>
                    $100.00 per family *Due upon registration & any lengthy
                    withdraw and re-enroll *non-refundable <br />
                    <span id="parHeader"> Preschool: </span> 3 years old and
                    Potty trained.
                    <br />
                    <span id="parHeader"> Full-Time: </span> 4 or 5 days of
                    child care Monday-Friday consisting of 5 or more hours per
                    day
                    <br />
                    <span id="parHeader"> Part-Time: </span> Children who
                    enrolled 2-3 days a week
                    <br />
                    <span id="parHeader"> Snow Days:</span> As a courtesy to our
                    families, you may drop off your school aged child (up to the
                    age of 12) and be charged the daily rate($100). This service has
                    limited enrollment. PLEASE ALWAYS CALL AHEAD FOR
                    CONFIRMATION. For Families already enrolled in our Before &
                    After care Program the fee is $50.00 a day.
                    <br />
                    <span id="parHeader"> Late Pick Up Fee: </span>$40 per child
                    every 10 minutes here past 5:30 pm Monday--Thursday & 5:15pm
                    Friday.
                    <br />
                    <span id="parHeader"> 1st Child: </span>1st child means the youngest
                    enrolled in the family.
                    <br />
                    <span id="parHeader"> **2 ½ Hour Preschool: </span>
                    Monday - Friday, Preschool 9-11:30am for $180
                </p>
                <br />
                <h2>
                    ***Hours of Operation: Monday thru Thursday 6:30AM—5:30PM
                    Friday 6.30AM—5:15PM*** Effective 1/6/2026

                </h2>
                <br />
            </div>
            <div>
                <p className="sectionHeaderPrograms">
                    <NavLink to="/tuition">
                        {" "}
                        How to Pay Tuition
                        <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"></i>
                        <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"></i>
                    </NavLink>
                </p>
            </div>
        </div>
    );
}
